import React from "react";

export function BrandMark({ size = 34 }: { size?: number }) {
  return (
    <span className="cm-brand-mark" style={{ width: size, height: size }} aria-hidden="true">
      <svg viewBox="0 0 298 264" fill="none">
        <path d="M122 12.5H88.5c-6.1 0-11.7 3.2-14.7 8.5l-59 102.2a17 17 0 0 0 0 17l59 102.2c3 5.3 8.6 8.5 14.7 8.5H122" />
        <path d="M164.8 250.9V12.5l51 140.1.5-140.1 68.9 119.2-68.9 119.2" />
      </svg>
    </span>
  );
}

export function BrandLockup({ subtitle = "NegoCity Banking Authority", compact = false }: { subtitle?: string; compact?: boolean }) {
  return (
    <span className={`cm-brand-lockup ${compact ? "compact" : ""}`}>
      <BrandMark size={compact ? 30 : 40} />
      <span><strong>Crédit Mabligop</strong><small>{subtitle}</small></span>
    </span>
  );
}
